import React from 'react';

import { Checkbox, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';

import type { RoomAssetLink } from '../packageOptions/types';

import { EGS_APPLY_MODE_LABELS } from './egsModel';
import type { EgsApplyMode } from './types';

interface Props {
  currentRoom: string;
  disabled?: boolean;
  mode: EgsApplyMode;
  onModeChange: (mode: EgsApplyMode) => void;
  onRoomsChange: (rooms: Array<string>) => void;
  rooms: Array<RoomAssetLink>;
  selectedRooms: Array<string>;
  title: string;
}

export default function EgsRoomScopeControl({
  currentRoom,
  disabled,
  mode,
  onModeChange,
  onRoomsChange,
  rooms,
  selectedRooms,
  title,
}: Props) {
  const toggleRoom = (room: string, checked: boolean) => {
    const next = checked ? [...selectedRooms, room] : selectedRooms.filter((selected) => selected !== room);
    onRoomsChange(next);
  };

  return (
    <Stack spacing={0.5}>
      <FormLabel component="legend">
        <Typography color="text.secondary" variant="caption">
          {title}
        </Typography>
      </FormLabel>
      <RadioGroup onChange={(_event, value) => onModeChange(value as EgsApplyMode)} row value={mode}>
        {(Object.keys(EGS_APPLY_MODE_LABELS) as Array<EgsApplyMode>).map((value) => (
          <FormControlLabel
            control={<Radio disabled={disabled} size="small" />}
            key={value}
            label={EGS_APPLY_MODE_LABELS[value]}
            value={value}
          />
        ))}
      </RadioGroup>
      {mode === 'particular' && (
        <Stack direction="row" flexWrap="wrap" useFlexGap>
          {rooms.map((room) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={room.id === currentRoom || selectedRooms.includes(room.id)}
                  disabled={disabled || room.id === currentRoom}
                  onChange={(event) => toggleRoom(room.id, event.target.checked)}
                  size="small"
                />
              }
              key={room.id}
              label={room.id === currentRoom ? `${room.name} (current)` : room.name}
            />
          ))}
        </Stack>
      )}
    </Stack>
  );
}
